import React from "react";

const Deploy = ({ translate }) => {
  return (
    <div className="content active">
      <h2>{translate("deployLogs")}</h2>
      <div className="deploy-logs">
        <ul>
          <li>این سرویس بزودی ایجاد خواهد شد ...</li>
        </ul>
      </div>
    </div>
  );
};

export default Deploy;